import React, { useState } from 'react';
import { Gift, Heart, Copy, CheckCircle, Link as LinkIcon } from 'lucide-react';

const SharePage = ({ giftId, magicLink, onCreateNew }) => {
    const shareUrl = `${window.location.origin}?gift=${giftId}`;
    const [copied, setCopied] = useState(false);
    const [copiedMagic, setCopiedMagic] = useState(false);

    const copyToClipboard = (text, isMagic = false) => {
        navigator.clipboard.writeText(text);
        if (isMagic) {
            setCopiedMagic(true);
            setTimeout(() => setCopiedMagic(false), 2000);
        } else {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-indigo-950 via-purple-950 to-indigo-900 text-white flex items-center justify-center px-4">
            <div className="max-w-2xl w-full">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-yellow-400/20 mb-6 animate-bounce">
                        <Gift className="w-10 h-10 text-yellow-300" />
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">
                        تم إنشاء هديتك! 🎉
                    </h1>
                    <h2 className="text-2xl md:text-3xl text-purple-200 mb-4">
                        Your Gift is Ready!
                    </h2>
                    <p className="text-lg text-purple-300">
                        شارك الرابط مع الشخص العزيز عليك
                    </p>
                </div>

                <div className="bg-white/10 backdrop-blur-lg rounded-xl p-8 space-y-6">
                    {/* Normal Link */}
                    <div>
                        <label className="block text-sm text-purple-300 mb-2">
                            رابط الهدية (عادي)
                        </label>
                        <div className="flex gap-2">
                            <input
                                type="text"
                                value={shareUrl}
                                readOnly
                                className="flex-1 px-4 py-3 rounded-lg bg-white/20 border border-white/30 text-white text-sm"
                            />
                            <button
                                onClick={() => copyToClipboard(shareUrl)}
                                className="px-6 py-3 rounded-lg bg-yellow-400 hover:bg-yellow-500 text-indigo-950 font-bold transition-all"
                            >
                                {copied ? <CheckCircle className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
                            </button>
                        </div>
                    </div>

                    {/* Magic Link */}
                    {magicLink && (
                        <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
                            <div className="flex items-center gap-2 mb-2">
                                <LinkIcon className="w-5 h-5 text-green-400" />
                                <label className="text-sm text-green-300 font-bold">
                                    🔗 Magic Link (رابط مباشر - بدون كلمة سر)
                                </label>
                            </div>
                            <p className="text-xs text-green-200 mb-3">
                                هذا الرابط يفتح الهدية مباشرة بدون الحاجة لإدخال كلمة سر
                            </p>
                            <div className="flex gap-2">
                                <input
                                    type="text"
                                    value={magicLink}
                                    readOnly
                                    className="flex-1 px-4 py-3 rounded-lg bg-white/20 border border-green-500/30 text-white text-sm"
                                />
                                <button
                                    onClick={() => copyToClipboard(magicLink, true)}
                                    className="px-6 py-3 rounded-lg bg-green-500 hover:bg-green-600 text-white font-bold transition-all"
                                >
                                    {copiedMagic ? <CheckCircle className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
                                </button>
                            </div>
                        </div>
                    )}

                    <div className="border-t border-white/20 pt-6">
                        <button
                            onClick={onCreateNew}
                            className="w-full bg-white/10 hover:bg-white/20 text-white font-bold py-3 rounded-lg transition-all flex items-center justify-center gap-2"
                        >
                            <Heart className="w-5 h-5" />
                            إنشاء هدية أخرى
                        </button>
                    </div>

                    <div className="text-center text-sm text-purple-300">
                        <p>💡 احفظ الرابط ده في مكان آمن</p>
                        {magicLink && (
                            <p className="mt-2 text-xs text-green-300">
                                🔒 Magic Link يفتح الهدية مباشرة - احتفظ به بشكل آمن!
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SharePage;